<template>
    <div class="personalInfo">
        <h3>{{'components/settings/personal-info.title' | trans}}</h3>
        <div class="form">
            <transition name="fade">
                <div v-if="addressSelectLoading"  class="loadingOverlay"></div>
            </transition>
			<div class="inputWrap">
				<label>{{ 'components/settings/personal-info.full-name' | trans }}</label>
				<div class="inputInnerWrap">
					<span class="inputType">{{ this.user.name }}</span>
				</div>
			</div>
            <Input
				:label="'components/settings/personal-info.phone-number' | trans"
                id="phone"
                v-model="phone"
            />
            <Input
				:label="'components/settings/personal-info.email' | trans"
                type="email"
                id="email"
                v-model="email"
            />


            <div class="selectWrap">
                <label>{{'components/settings/personal-info.home-address' | trans}}</label>
                <v-select
                    :options="addresses"
                    v-model="selectedAddress"
                    placeholder="'components/settings/personal-info.select-address' | trans"
                    class="formSelect"
                />
            </div>

            <div class="inputWrap">
                <PulseLoader v-if="userInfoLoading" size="8px" color="#00B2FF"/>
                <button v-else @click="updatePersonalInfo" class="btn btn-block">{{'components/settings/personal-info.update' | trans}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Input from '../form/Input';
    import vSelect from 'vue-select';
    import {mapState, mapActions} from 'vuex';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        data() {
            return {
                phone: '',
                email: '',
                selectedAddress: {},
                addressSelectLoading: false
            }
        },
        components: {Input, vSelect, PulseLoader},
        methods: {
            ...mapActions(['getAddresses', 'updateUserData', 'addMessage', 'getUserInfo']),
            updatePersonalInfo: function () {
                this.addressSelectLoading = true;
                this.updateUserData({
                    email: this.email,
                    phone: this.phone,
                    addressId: this.selectedAddress ? this.selectedAddress.value : null,
                })
                    .then(response => {
                        return this.getUserInfo().then(r => response)
                    })
                    .then(response => this.addMessage(response.data.messages))
                    .catch(error => console.log(error))
                    .finally(() => this.addressSelectLoading = false);
            },
            initAddressSelectData: function () {
                for (let address of this.addresses) {
                    if (this.user.addresses && address.value === this.user.addresses.residentialAddressId) {
                        this.selectedAddress = {
                            label: address.label,
                            value: address.value
                        };
                        break;
                    }
                }
            }
        },
        computed: {
            ...mapState(['addressBook', 'user', 'userInfoLoading']),
            addresses: function () {
                return this.addressBook.map(function (address) {
                    return {
                        'label': address.full_address,
                        'value': address.id
                    };
                });
            }
        },
        created() {
            this.addressSelectLoading = true;
            if (!this.addressBook || this.addressBook.length < 1) {
                this.getAddresses().then(r => {
                    this.initAddressSelectData();
                    this.addressSelectLoading = false;
                }).catch(e => {
                    console.log(e);
                    this.addressSelectLoading = false;
                });
            } else {
                this.initAddressSelectData();
                this.addressSelectLoading = false;
            }

            this.phone = this.user.phone;
            this.email = this.user.email;
        }
    }
</script>
